<template>
  <power-bi code="eyJrIjoiYzc4YjAyMDctMzY0Ni00YmNkLTkwN2UtNDZhYWRmZjQxNGYwIiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9" />
</template>

<script>
import PowerBi from '../components/PowerBi.vue';

export default {
    components: {
        PowerBi,
    },
};
</script>
